import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";

/**
 * Updates an existing category in the backend.
 *
 * @param {string} categoryId
 * @param {Object} categoryData
 * @returns {Promise<Object>}
 */
const updateCategory = async (categoryId, categoryData) => {
  return apiCall(
    `${AUTH_ROUTES.CATEGORIES_API_ENDPOINT}/${categoryId}`,
    {
      method: "PUT",
      body: categoryData,
    }
  );
};

export default updateCategory;
